import { useTranslation } from 'react-i18next';

import { PageHeader } from '@/components/ui/PageHeader';
import { WatermarkLayer } from '@/components/protection/Watermark';
import { YouTubePlayer } from '@/components/media/YouTubePlayer';

/**
 * Витрина правок интерфейса — «посмотреть, прежде чем поверить».
 *
 * ⚠️ ЗАЧЕМ ОНА. Заказчик 07.09.2026: «на прод не закидывай, тестово отдельную
 * страничку сделай чтобы я прочекал сперва». Отдельную копию сайта поднять не
 * вышло — под неё нужна своя запись в DNS, а открывать лишний порт в защите
 * сервера ради проверки нельзя. Витрина внутри админки решает ту же задачу
 * дешевле: правку видно вживую, на настоящем куске приложения, а не на снимке.
 *
 * ⚠️ ЗДЕСЬ ТОЛЬКО ПЛЕЕР, И ЭТО СОЗНАТЕЛЬНО. Заказчик в тот же день: «там сделай
 * только ролик и все». Остальные правки — значок заметки, число уроков, уровень
 * CEFR — проверяются по снимку «было/стало» и живого показа не требуют. А плеер
 * требует: у него надо НАЖАТЬ разворот и убедиться, что водяной знак остался
 * поверх видео. По картинке это не проверить.
 *
 * Страница живёт под /admin, ученикам не видна.
 */

/** Ролик из настоящего урока — чтобы плеер вёл себя ровно как в бою. */
const DEMO_VIDEO = 'KMlLJz0Y5pQ';

export function AdminPreviewPage() {
  const { t } = useTranslation();

  return (
    <>
      <PageHeader title={t('adminPreview.title')} subtitle={t('adminPreview.subtitle')} />

      <div className="mx-auto max-w-[620px]">
        <YouTubePlayer videoId={DEMO_VIDEO} overlay={<WatermarkLayer />} />
      </div>

      <p className="mx-auto mt-4 max-w-[620px] px-1 text-[13px] leading-[1.55] text-on-surface-variant">
        {t('adminPreview.note')}
      </p>
    </>
  );
}
